import React from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { matchPath, useLocation } from "react-router-dom";
import routing from "../../../routing";

import Opus from "./Opus";
import Rhythm from "./Rhythm";
import Pitch from "./Pitch";
import messages from "./messages";
import {
    NavElement,
    Nav,
    StyledMeta,
    Page,
} from "./styles";
import { IProps } from "./interfaces";

const Meta = ({ plan, publicView, type }: IProps) => {
    const location = useLocation();
    return (
        <StyledMeta>
            <Nav>
                <div>
                    <NavElement
                        replace
                        rel="nofollow"
                        to={`/${type}/${plan._id}/${routing.meta}/${routing.metaOpus}`}
                        className={cn({
                            active: location.pathname.slice(-routing.meta.length) === routing.meta,
                        })}
                    >
                        <FormattedMessage {...messages.opus} />
                    </NavElement>
                    <NavElement
                        replace
                        rel="nofollow"
                        to={`/${type}/${plan._id}/${routing.meta}/${routing.metaRhythm}`}
                    >
                        <FormattedMessage {...messages.rhythm} />
                    </NavElement>
                    <NavElement
                        replace
                        rel="nofollow"
                        to={`/${type}/${plan._id}/${routing.meta}/${routing.metaPitch}`}
                    >
                        <FormattedMessage {...messages.pitch} />
                    </NavElement>
                </div>
            </Nav>
            <Page>
                {matchPath(`/${type}/:id/${routing.meta}`, location.pathname) && (
                    <Opus publicView={publicView} plan={plan} />
                )}
                {matchPath({ path: `/${type}/:id/${routing.meta}/${routing.metaOpus}`, end: false }, location.pathname) && (
                    <Opus publicView={publicView} plan={plan} />
                )}
                {matchPath({ path: `/${type}/:id/${routing.meta}/${routing.metaRhythm}`, end: false }, location.pathname) && (
                    <Rhythm publicView={publicView} plan={plan} />
                )}
                {matchPath({ path: `/${type}/:id/${routing.meta}/${routing.metaPitch}`, end: false }, location.pathname) && (
                    <Pitch publicView={publicView} plan={plan} />
                )}
            </Page>
        </StyledMeta>
    );
}

export default Meta;
